module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profileBox"
  }, [_c('div', {
    staticClass: "smallFont"
  }, [_vm._v("Logged in as")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.user.permissions.admin > 0) ? _c('router-link', {
    staticClass: "profile-button admin",
    attrs: {
      "to": "/admin"
    }
  }, [_vm._v("Admin Panel")]) : _vm._e(), _vm._v(" "), (_vm.user.permissions.admin > 0) ? _c('p', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "profile-button",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Log out")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46a2220e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/frame/header/profile.vue
// module id = 668
// module chunks = 30